module.exports = __webpack_public_path__ + "static/electronjs-b797a91818a6b4151998f4f0a4c7a5b1.png";